import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getBaseUrl } from "../../utils/general/getBaseUrl";
import { CUSTOMER } from "../../utils/constants/customer.constants";

export const reportApi = createApi({
    reducerPath: "reportApi",
    tagTypes: ["Report"],
    baseQuery: fetchBaseQuery({
        baseUrl: getBaseUrl(),
    }),
    endpoints: (builder) => ({
        getSalesByProduct: builder.query<
            [],
            {
                page?: number;
                limit?: number;
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ page = 1, limit = 10, from_date, to_date }) => {
                const queryParams = {
                    url: "reports/sales-by-products",
                    params: { page, limit },
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        getAllDeliveryOrderByItem: builder.query<
            [],
            {
                page?: number;
                limit?: number;
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ page = 1, limit = 10, from_date, to_date }) => {
                const queryParams = {
                    url: "reports/delivery-order-by-item-report",
                    params: { page, limit },
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        getAllDeliveryOrderByCustomer: builder.query<
            [],
            {
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ from_date, to_date }) => {
                const queryParams = {
                    url: "reports/delivery-order-by-customer-report",
                    params: {},
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        getSalesByProductCustomer: builder.query<
            [],
            {
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ from_date, to_date }) => {
                const queryParams = {
                    url: "reports/sales-by-products-customer",
                    params: {},
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        getSalesByProductCategory: builder.query<
            [],
            {
                page?: number;
                limit?: number;
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ page = 1, limit = 10, from_date, to_date }) => {
                const queryParams = {
                    url: "reports/sales-by-product-categories",
                    params: { page, limit },
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        getDeliveredGoodIssue: builder.query<
            [],
            {
                page?: number;
                limit?: number;
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ page = 1, limit = 10, from_date, to_date }) => {
                const queryParams = {
                    url: "reports/delivered-good-issue",
                    params: { page, limit },
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        getPendingDeliveryGoodIssues: builder.query<
            [],
            {
                page?: number;
                limit?: number;
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ page = 1, limit = 10, from_date, to_date }) => {
                const queryParams = {
                    url: "reports/pending-delivery-good-issues",
                    params: { page, limit },
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        getAllCustomerSalesAnalysis: builder.query<
            [],
            {
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ from_date, to_date }) => {
                const queryParams = {
                    url: "reports/customer-sales-analysis-report",
                    params: {},
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        getIssuedItemByRequestReason: builder.query<
            [],
            {
                page?: number;
                limit?: number;
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ page = 1, limit = 10, from_date, to_date }) => {
                const queryParams = {
                    url: "reports/issued-item-by-request-reason",
                    params: { page, limit },
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        exportDeliveredGoodIssue: builder.query<
            Blob,
            {
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ from_date, to_date }) => {
                const queryParams = {
                    url: "reports/delivered-good-issue/export",
                    params: {},
                    responseHandler: (response: Response) => response.blob(),
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        exportPendingDeliveryGoodIssue: builder.query<
            Blob,
            {
                page?: number;
                limit?: number;
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ page, limit, from_date, to_date }) => {
                const queryParams = {
                    url: "reports/pending-delivery-good-issues/export",
                    params: {},
                    responseHandler: (response: Response) => response.blob(),
                };

                if (page) {
                    //@ts-ignore
                    queryParams.params.page = page;
                }

                if (limit) {
                    //@ts-ignore
                    queryParams.params.limit = limit;
                }

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        exportIssuedItemByRequestReason: builder.query<
            Blob,
            {
                page?: number;
                limit?: number;
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ page, limit, from_date, to_date }) => {
                const queryParams = {
                    url: "reports/issued-item-by-request-reason/export",
                    params: {},
                    responseHandler: (response: Response) => response.blob(),
                };

                if (page) {
                    //@ts-ignore
                    queryParams.params.page = page;
                }

                if (limit) {
                    //@ts-ignore
                    queryParams.params.limit = limit;
                }

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        exportDeliveryOrderByItem: builder.query<
            Blob,
            {
                page?: number;
                limit?: number;
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ page, limit, from_date, to_date }) => {
                const queryParams = {
                    url: "reports/delivery-order-by-item-report/export",
                    params: {},
                    responseHandler: (response: Response) => response.blob(),
                };

                if (page) {
                    //@ts-ignore
                    queryParams.params.page = page;
                }

                if (limit) {
                    //@ts-ignore
                    queryParams.params.limit = limit;
                }

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        exportSalesByProduct: builder.query<
            Blob,
            {
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ from_date, to_date }) => {
                const queryParams = {
                    url: "reports/sales-by-products/export",
                    params: {},
                    responseHandler: (response: Response) => response.blob(),
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        exportSalesByProductCustomer: builder.query<
            Blob,
            {
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ from_date, to_date }) => {
                const queryParams = {
                    url: "reports/sales-by-products-customer/export",
                    params: {},
                    responseHandler: (response: Response) => response.blob(),
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
    }),
    keepUnusedDataFor: 0,
});

export const {
    useGetSalesByProductQuery,
    useGetSalesByProductCategoryQuery,
    useGetSalesByProductCustomerQuery,
    useGetDeliveredGoodIssueQuery,
    useGetIssuedItemByRequestReasonQuery,
    useGetPendingDeliveryGoodIssuesQuery,
    useGetAllDeliveryOrderByItemQuery,
    useGetAllDeliveryOrderByCustomerQuery,
    useGetAllCustomerSalesAnalysisQuery,
    useLazyExportDeliveredGoodIssueQuery,
    useLazyExportPendingDeliveryGoodIssueQuery,
    useLazyExportIssuedItemByRequestReasonQuery,
    useLazyExportDeliveryOrderByItemQuery,
    useLazyExportSalesByProductQuery,
    useLazyExportSalesByProductCustomerQuery,
} = reportApi;
